require('../../modules/es.array.includes');
var entryUnbind = require('../../internals/entry-unbind');

module.exports = entryUnbind('Array', 'includes');



//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/lepetitsalon/wp-content/themes/digitalcover/node_modules/core-js/es/array/includes.js
// module id = 89
// module chunks = 0